export default "__VITE_ASSET__1ccb6560__"